import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex content-start flex-1 flex-wrap flex-col sm:flex-row gap-4" }
const _hoisted_2 = { class: "flex gap-4 flex-col flex-[3] sm:min-w-[550px] w-full" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}

import { computed, ref, provide } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { Report } from "@/types/Report";
import ReportForm from "@/views/reports/components/ReportForm.vue";
import ReportPlot from "@/views/reports/components/ReportPlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFormWithPlot',
  props: {
    report: {},
    hierarchyTags: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isWidgetLoading = ref(false);

provide("loadingStateEmitterRef", isWidgetLoading);

// the form might do some unexpected mutations, would be nice to refactor it, so it doesn't mutate at all
const clonedReport = computed(() => structuredClone(props.report));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportForm, {
      report: clonedReport.value,
      hierarchyTags: _ctx.hierarchyTags,
      class: "h-min flex-1",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('change', $event)))
    }, null, 8, ["report", "hierarchyTags"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["bg-white border border-gray-200 shadow rounded-lg relative", { 'overflow-hidden': _ctx.report.type === 'query_value' }])
      }, [
        _createVNode(ReportPlot, {
          report: _ctx.report,
          spacingX: 8,
          spacingY: 12
        }, null, 8, ["report"]),
        (isWidgetLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(LoadingSpinner)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})